import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

import samsLogo from "../../Assets/Images/logo.png";
import sundaramLogo from "../../Assets/Images/sundaram.png";
import samsDigitalLogo from "../../Assets/Images/sams_digital.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <section className="footer p-0">
      <footer className="bg-dark text-white ">
        <div className="container-fluid ">
          <div className="row justify-content-between py-lg-5 pt-5">
            <div className="col-12 col-lg-3 col-md-12 mb-4 mb-lg-0">
              <div className="mb-3">
                <Link to="/">
                  <img
                    src={samsLogo}
                    alt="SAMS Events"
                    className="w-auto logo"
                  />
                </Link>
              </div>

              <p className="py-4">
                Talk to Us – We’re Just a Message Away. Whether you have a
                question, need assistance, or want to discuss your next big
                event, our team is here to help.
              </p>

              <Link to="/contact" className="text-decoration-none">
                <button className="btn get-in-touch rounded-0  px-3 mb-4">
                  Get In Touch
                </button>
              </Link>

              <hr className="border-white " />

              <p className="text-white small mb-2">Our Group of Companies</p>
              <div className="d-flex align-items-center mb-3">
                <a
                  href="https://sundarampublication.com/"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img
                    src={sundaramLogo}
                    alt="Sundaram"
                    className="me-3 w-auto"
                  />
                </a>

                <a
                  href="https://samsdigital.in/"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img
                    src={samsDigitalLogo}
                    alt="SAMS Digital"
                    className="w-auto"
                  />
                </a>
              </div>

              <hr className="border-white" />
            </div>

            {/* Center Links */}
            <div className="col-12 col-lg-3 col-md-6 foot-links mb-4 mb-lg-0">
              {" "}
              {/* Added col-12 and mb-4 */}
              <div className="row justify-content-evenly">
                <div className="col-6">
                  <ul className="list-unstyled small ">
                    <li className="py-3">
                      <Link
                        to="/about"
                        className="text-white text-decoration-none">
                        About us
                      </Link>
                    </li>
                    <li className="py-3">
                      <Link
                        to="/service"
                        className="text-white text-decoration-none">
                        Services
                      </Link>
                    </li>
                    <li className="py-3">
                      <Link
                        to="/gallery"
                        className="text-white text-decoration-none">
                        Gallery
                      </Link>
                    </li>
                    <li className="py-3">
                      <Link
                        to="/contact"
                        className="text-white text-decoration-none">
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col-6">
                  <ul className="list-unstyled small">
                    <li className="py-3">
                      <Link
                        to="/legacy"
                        className="text-white text-decoration-none">
                        Our Legacy
                      </Link>
                    </li>
                    <li className="py-3">
                      <Link
                        to="/faq"
                        className="text-white text-decoration-none">
                        FAQ
                      </Link>
                    </li>
                    <li className="py-3">
                      <Link
                        to="/blog-page"
                        className="text-white text-decoration-none">
                        Blogs
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Right Socials */}
            <div className="col-12 col-lg-3 col-md-6 foot-socials">
              {" "}
              {/* Added col-12 */}
              <div className="d-flex flex-column justify-content-center mx-auto h-100 ">
                <p className=" mb-4 text-white">CONNECT WITH US</p>
                <div className="row  mb-3">
                  <div className="col-2">
                    <a
                      href="https://www.facebook.com/people/Sams-digital/61554156599400/"
                      title="Facebook"
                      className="text-white"
                      target="_blank"
                      rel="noopener noreferrer">
                      {" "}
                      <FontAwesomeIcon icon={faFacebook} />
                    </a>
                  </div>
                  <div className="col-2">
                    <a
                      href="https://www.instagram.com/sams__digital/"
                      title="Instagram"
                      className="text-white"
                      target="_blank"
                      rel="noopener noreferrer">
                      {" "}
                      <FontAwesomeIcon icon={faInstagram} />
                    </a>
                  </div>
                  <div className="col-2">
                    <a
                      href="https://www.linkedin.com/company/samsdigitalin/"
                      title="Linkedin"
                      className="text-white"
                      target="_blank"
                      rel="noopener noreferrer">
                      <FontAwesomeIcon icon={faLinkedin} />
                    </a>
                  </div>
                  <div className="col-2">
                    <a
                      href="https://youtube.com/@samsdigital3617?si=fHMXC9PlpvtkslOH"
                      alt="Youtube"
                      target="_blank"
                      className="text-white"
                      rel="noopener noreferrer">
                      <FontAwesomeIcon icon={faYoutube} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-between py-4">
            <div className="col-lg-auto">
              <Link to="/privacy-policy" className="text-white me-3">
                Privacy Policy
              </Link>
              <Link to="/terms-condition" className="text-white">
                Terms
              </Link>
            </div>
            <div className="col-md-auto text-md-end text-white pt-3 pt-lg-0">
              © 2025 SAMS Digital. All rights reserved.
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default Footer;
